module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/good-price/good-price.component.sass
// module id = ./src/app/modules/user/components/good-price/good-price.component.sass
// module chunks = main